import React from "react";
import Slider from "react-slick";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const ImageCarousel = ({ images, closeModal }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  function decodeBase64ToImage(base64String) {
    return `data:image/png;base64,${base64String}`;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: "10%",
        left: "50%",
        transform: "translate(-50%, 0)",
        width: "90%",
        height: "90%",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        borderRadius: "8px",
      }}
    >
      {/* Close Button */}
      <button
        onClick={closeModal}
        style={{
          position: "absolute",
          top: "15px",
          right: "15px",
          backgroundColor: "red",
          color: "white",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.2)",
          zIndex: 1001,
        }}
      >
        <FontAwesomeIcon icon={faTimes} size="lg" />
      </button>

      {/* Carousel */}
      <div style={{ width: "100%", height: "100%" }}>
        {images.length > 0 ? (
          <Slider {...settings}>
            {images.map((image, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: "100%",
                }}
              >
                <Zoom>
                  <img
                    src={decodeBase64ToImage(image.file_base64)}
                    alt={`Image ${index}`}
                    style={{
                      maxHeight: "70vh",
                      maxWidth: "90vw",
                      objectFit: "contain",
                      margin: "auto",
                    }}
                  />
                </Zoom>
              </div>
            ))}
          </Slider>
        ) : (
          <p style={{ textAlign: "center", marginTop: "20px" }}>
            Leider hat dieses Beacon kein Bild
          </p>
        )}
      </div>
    </div>
  );
};

export default ImageCarousel;
